import React from 'react';
import { FiFacebook } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const facebookUrl = "https://www.facebook.com/share/1CcMBE2nDA/";

  return (
    <footer className="bg-royal text-white py-12 border-t-4 border-brandOrange">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10">
          <div className="flex flex-col items-center md:items-start max-w-sm">
            <img 
              src="https://i.postimg.cc/4ymm6Lnt/CRoss.png" 
              alt="Crossroads Driving School Logo" 
              className="h-8 w-auto mb-6 bg-white p-1 rounded" 
            />
            <p className="text-blue-200 text-sm text-center md:text-left leading-relaxed">
              Professional automatic driving tuition in Weston-super-Mare and surrounding areas. 
              Building confident, safe drivers for life through patient and expert instruction.
            </p>
            <div className="flex gap-4 mt-6">
              <a 
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800/50 rounded-full flex items-center justify-center hover:bg-brandOrange transition-all border border-blue-700"
                aria-label="Follow us on Facebook"
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-12">
            <div>
              <h4 className="font-bold text-lg mb-6 border-b border-blue-800 pb-2">Navigation</h4>
              <div className="flex flex-col gap-3 text-blue-200">
                <a href="#home" className="hover:text-brandOrange transition-colors">Home</a>
                <a href="#about" className="hover:text-brandOrange transition-colors">About Us</a>
                <a href="#services" className="hover:text-brandOrange transition-colors">Our Services</a>
                <a href="#contact" className="hover:text-brandOrange transition-colors">Contact</a>
              </div>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-6 border-b border-blue-800 pb-2">Support</h4>
              <div className="flex flex-col gap-3 text-blue-200">
                <a href="tel:07824448455" className="hover:text-brandOrange transition-colors">07824 448455</a>
                <a 
                  href={facebookUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-brandOrange transition-colors"
                >
                  Facebook Page
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-blue-800 text-center text-sm text-blue-300 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p>&copy; {new Date().getFullYear()} Crossroads Driving School. All rights reserved.</p>
          <div className="flex gap-6">
            <p>Terms & Conditions</p>
            <p>Privacy Policy</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;